import axios, { AxiosInstance } from 'axios'
import { IAssetData } from './types'

const api: AxiosInstance = axios.create({
  baseURL: 'https://ethereum-api.xyz',
  timeout: 30000, // 30 secs
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

const chainToProvider = {
    4: 'http://localhost:5001/fyatluxtest/us-central1/api',
    1: 'https://us-central1-fyatluxtest.cloudfunctions.net/api'
}

export async function apiGetCheckoutChallenge(address: string, chainId:number): Promise<string> {
    return new Promise<string>(async(resolve, reject) => {
      try {
         const res = await axios.get(chainToProvider[chainId] + '/challenge/' + address)
        console.log(res)
         resolve(res.data.challenge)
      } catch (error) {
        reject("Error accessing api.")
      }
    })
}

export async function apiSubmitChallenge(address: string, signature: string, chainId:number): Promise<string> {
    const bodyParameters = {'challenge': signature};

    return new Promise<string>(async(resolve, reject) => {
      try {
         const res = await axios.post(chainToProvider[chainId] + '/checkout/' + address, bodyParameters)
         resolve(res.data.link)
      } catch (error) {
        reject("Challenge failed.")
      }
    })
}

export async function apiGetAccountAssets(
  address: string,
  chainId: number
): Promise<IAssetData[]> {
  const response = await api.get(
    `/account-assets?address=${address}&chainId=${chainId}`
  )
  const { result } = response.data
  return result
}

